/*@ngInject*/
const UserListController = function ($rootScope, $scope, $state, $stateParams, $timeout, userType, coreConstant, userMediator, localization, userUtil, navigationStateModel, userManagementAction, userListActionsUtil, modalUtil, userStatus) {

    localization.getTranslationByKey('userList').then(function (translations) {

        $scope.initialSortConfig = {key: 'name', sortType: 'asc'};

        $scope.viewModel = {
            isLoading: false,
            isAgencyUsers: false,
            hideInactiveUsers: false,
            adminUsersOnly: false,
            userSearchTerm: '',
            userRecordList: [],
            totalUserRecords: 0,
            startIndex: 0,
            pageSize: 10,
            key: 'name',
            sortType: 'asc',
            userType: parseInt($stateParams.userType),
            title: '',
            recordCountText: _.get(translations, 'userCount'),
            recordsCountText: _.get(translations, 'usersCount'),
            userSearchTermPlaceholder: _.get(translations, 'userSearchTermPlaceholder')
        };
        $scope.viewModel.isAgencyUsers = $scope.viewModel.userType===userType.AGENCY_BROKERAGE;

        $scope.actions = [];
        $scope.hiddenInputActions = {};
        $scope.context = {
            identifier: 'userList',
            actions: {},
            fallthrough: null,
            model: {
                contextType: coreConstant.CONTEXT_NONE
            }
        };
        $scope.context.actions[coreConstant.CONTEXT_NONE] = '';

        function loadActions() {
            userMediator.loadUserActions($stateParams.userType, /*userId*/null).then(function (actions) {
                let allActions = [];
                allActions.push({
                    actions: actions.actions,
                    contextType: $scope.context.model.contextType
                });
                $scope.actions = allActions;

                $scope.hiddenInputActions = {};
                $scope.hiddenInputActions[userManagementAction.IMPORT_UW_LOAS] = 'application/xml';

                $scope.actionsTimeLastModified = new Date().getTime();
            });
        }

        function loadUserList() {
            const viewModel = userMediator.restoreViewState('userList:' + $stateParams.userType);
            if (!_.isNil(viewModel)) {
                $scope.viewModel = viewModel;
            }

            const params = {
                userType: $scope.viewModel.userType,
                hideInactiveUsers: $scope.viewModel.hideInactiveUsers,
                adminUsersOnly: $scope.viewModel.adminUsersOnly,
                searchString: $scope.viewModel.userSearchTerm,
                key: $scope.viewModel.key,
                sortType: $scope.viewModel.sortType,
                startIndex: $scope.viewModel.startIndex,
                pageSize: $scope.viewModel.pageSize
            };

            $scope.viewModel.isLoading = true;

            userMediator.loadUserList(params).then(function (result) {

                _.each(result.records, function (user) {
                    if (_.isNil(user.name)) {
                        user.name = _.get(translations, 'draftUserName');
                    } else {
                        const name = _.isEmpty(user.name) ? user.firstName + ' ' + user.lastName : user.name;
                        user.name = _.isEmpty(name.trim()) ? _.get(translations, 'draftUserName') : name;
                    }
                    user.statusLabel = _.get(translations, 'status.' + user.status);
                    if (user.locked) {
                        user.statusLabel += ' ' + _.get(translations, 'lockedLabel');
                    }
                    user.isDraftStatus = user.status === userStatus.STATUS_DRAFT;
                });

                $scope.viewModel.userRecordList = result.records;

                $scope.viewModel.totalUserRecords = result.totalRecords;
                $scope.viewModel.isGridEmpty = $scope.viewModel.userRecordList.length === 0;

                $timeout(function () {
                    $rootScope.$broadcast(coreConstant.event.RECALCULATE_GRID_PAGING);
                    $scope.viewModel.isLoading = false;
                }, 0);
            });

            userMediator.saveViewState('userList:' + $stateParams.userType, null);
            navigationStateModel.saveViewState('userList:', null);
        }

        $scope.onClickRow = function (user) {
            let navigationModel = {
                parentState: 'userList:' + $stateParams.userType,
                currentState: 'manageUser',
                data: {
                    userId: user.id,
                    userType: parseInt($stateParams.userType)
                }

            };
            userMediator.saveViewState(navigationModel.parentState, $scope.viewModel);
            $state.go('manageUser', {userId: user.id, userType: $scope.viewModel.userType});
            navigationStateModel.saveViewState(navigationModel.parentState, navigationModel);
        };

        $scope.onHideInactiveUsersChanged = function () {
            userMediator.saveViewState('userList:' + $stateParams.userType, $scope.viewModel);
            loadUserList();
        };

        $scope.onAdminUsersOnlyChanged = function () {
            userMediator.saveViewState('userList:' + $stateParams.userType, $scope.viewModel);
            loadUserList();
        };

        $scope.onClearSearchTerm = function () {
            $scope.viewModel.userSearchTerm = '';
            $scope.viewModel.startIndex = 0;
            userMediator.saveViewState('userList:' + $stateParams.userType, null);
            loadUserList();
            $rootScope.$broadcast(coreConstant.event.RESET_GRID_PAGING);
        };

        $scope.onUserSearchTermChanged = _.debounce(function () {
            $scope.viewModel.startIndex = 0;
            userMediator.saveViewState('userList:' + $stateParams.userType, null);
            loadUserList();
            $rootScope.$broadcast(coreConstant.event.RESET_GRID_PAGING);
        }, 750);

        $scope.onPagingChange = function ($event, params) {
            $scope.viewModel.startIndex = params.startIndex;
            loadUserList();
        };

        $scope.onSortChange = function (event, params) {
            $scope.viewModel.key = params.key;
            $scope.viewModel.sortType = params.sortType;
            loadUserList();
        };

        $scope.getUserStatus = function (user) {
            return _.get(translations, 'status.' + user.status);
        };

        $scope.$on('$destroy', function () {
            userMediator.saveViewState($state.name, $scope.viewModel);
        });

        function checkPreviousViewState() {
            let state = userMediator.getPreviousViewState($state.name);
            if (!_.isNil(state)) {
                if (state.userType !== parseInt($stateParams.userType)) {
                    loadUserList();
                } else {
                    userMediator.restoreViewState($state.name, $scope.viewModel);
                    loadUserList();
                }
            } else {
                loadUserList();
            }
        }

        $scope.handleAction = function (action, file) {
            if (action.enabled) {
                switch (action.name) {
                    case userManagementAction.CREATE_USER:
                        userListActionsUtil.createUser($stateParams.userType);
                        break;

                    case userManagementAction.EXPORT_UW_LOAS:
                        userListActionsUtil.exportUWLOAs().then(() => {
                            loadActions();
                        });
                        break;

                    case userManagementAction.IMPORT_UW_LOAS:
                        userListActionsUtil.importUWLOAs(file).then(() => {
                            loadActions();
                        });
                        break;

                    default:
                        modalUtil.showActionNotImplementedModal(action.name);
                        break;
                }
            }
        };

        loadActions();
        checkPreviousViewState();
        $scope.viewModel.title = userUtil.getTitleFromStateParam(parseInt($stateParams.userType));
    });

    $scope.$on(ux.datagrid.events.ON_STARTUP_COMPLETE, function () {
        $scope.$apply();
    });
};

angular.module('umCore')
    .controller('userListController', UserListController);
